import React from "react";
import GoogleReviews from "../components/GoogleReviews"
export default function Reviews() {
  return (
    <>
 <GoogleReviews/>
    </>
  );
}
